var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-full-screen-file-drop",class:_vm.classes},[_vm._t("default",[_c('div',{staticClass:"content"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }